var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("数据更新时间："+_vm._s(_vm.synchronizeTime))])}
var staticRenderFns = []

export { render, staticRenderFns }